module.exports = __webpack_public_path__ + "static/media/HomeTab7.1a78bd02.jpg";